import { IUseSavingProposalResponse } from "../../../../../hooks/robot/useSavingProposal/types";
import { ISavingPropositionFund } from "../../../../../types/robot/ISavingPropositionFund";

export interface CustomFund {
  isin: string;
  name: string;
  type: string;
  percentage: number;
  sfdrRating?: number;
  morningstarSustainabilityRating?: number;
}

export const MapFundsToList = (response: IUseSavingProposalResponse | undefined) => {
  if (response === undefined) return [];
  const propositionFunds = [] as ISavingPropositionFund[];
  const customFunds = [] as CustomFund[];

  const funds = response.data?.funds;
  if (funds === undefined) return [];

  funds.forEach(fund => {
    propositionFunds.push(fund);
  });

  propositionFunds.forEach(fund => {
    if (!fund.combinationChildFunds.length) {
      customFunds.push({
        isin: fund.isin,
        name: fund.name,
        percentage: fund.percentageOfTotal,
        type: fund.type,
        morningstarSustainabilityRating: fund.morningstarSustainabilityRating,
        sfdrRating: fund.sfdrRating,
      });
    } else {
      fund.combinationChildFunds.forEach(combinationFund => {
        customFunds.push({
          isin: combinationFund.isin,
          name: combinationFund.name,
          type: combinationFund.type,
          morningstarSustainabilityRating: combinationFund.morningstarSustainabilityRating,
          sfdrRating: combinationFund.sfdrRating,
          percentage: combinationFund.percentageOfTotal,
        });
      });
    }
  });

  return customFunds;
};
